import ChartContainer from '../Services/charts/apex-charts/ChartContainer';

export const DistributedBars = ({ title, values = [], subtitles = [], colors = [], height = 350 }) => {
    const options = {
        chart: {
            type: 'bar',
            height,
            toolbar: {
                show: true
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                distributed: true,
                dataLabels: {
                    position: 'top'
                }
            }
        },
        legend: {
            show: false
        },
        dataLabels: {
            enabled: true,
            formatter: (val) => (val ? val.toLocaleString('pt-BR') : ''),
            style: {
                colors: ['#333']
            },
            offsetY: -20
        },
        xaxis: {
            categories: subtitles,
            labels: {
                style: {
                    fontSize: '12px',
                    colors: '#333'
                }
            }
        },
        yaxis: {
            labels: {
                formatter: (val) => (val ? val.toLocaleString('pt-BR') : '0')
            }
        },
        colors,
        tooltip: {
            y: {
                formatter: (val) => (val ? val.toLocaleString('pt-BR') : '0')
            }
        },
        grid: {
            show: false
        }
    };

    return (
        <ChartContainer
            title={title}
            options={options}
            series={[{ name: 'Total', data: values }]}
            type="bar"
            height={height}
        />
    );
};
